export const getGasAndElectricityCityAvailability = cityEligibilityData => {
  if (Object.entries(cityEligibilityData).length === 0) {
    return {
      gasAvailable: true,
      electricityAvailable: true,
      energyTypeDisabledOptions: [],
    }
  }

  const energyTypeDisabledOptions = []
  const gasEldAvailability = cityEligibilityData.gas === 2 && cityEligibilityData.availableGasProvider?.length
  const elecEldAvailability = cityEligibilityData.elec === 2 && cityEligibilityData.availableElectricityProvider.length

  const electricityAvailable = cityEligibilityData.elec === 1 || cityEligibilityData.elec === 3 || elecEldAvailability
  const gasAvailable = cityEligibilityData.gas === 1 || gasEldAvailability

  if (!electricityAvailable) energyTypeDisabledOptions.push('elec')
  if (!gasAvailable) energyTypeDisabledOptions.push('gas')

  if (!electricityAvailable || !gasAvailable) energyTypeDisabledOptions.push('dual')
  // Temporary do not block agents
  return { electricityAvailable, gasAvailable, energyTypeDisabledOptions: [] }
}
